module.exports = __webpack_public_path__ + "static/media/2.d963f126.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/2.png
// module id = 192
// module chunks = 6